<template>
  <transition name="confirm-fade">
    <!-- 阻止冒泡到父组件 阻止触摸滚动 -->
    <div class="confirm"
      v-show="showFlag"
      @click.stop
      @touchmove.prevent>
      <div class="confirm-wrapper">
        <div class="confirm-content"
          v-if="type==0">
          <!-- ccb 特有 -->
          <h2 class="title"
            v-if="BROSWER_TYPE=='16'">提示</h2>
          <!-- ccb 特有 -->
          <p class="text">{{text}}</p>
          <div class="operate">
            <div v-if="btnLen == 2"
              class="operate-btn left"
              @click="cancel">{{cancelBtnText}}</div>
            <div :style=" operateBtnStyle "
              class="operate-btn"
              @click="confirm">{{confirmBtnText}}</div>
          </div>
        </div>
        <div class="confirm-content avatar"
          v-if="type==1">
          <h2 class="title">请选择头像</h2>
          <div class="avatars">
            <div class="avatar"
              v-for="(item, index) in data"
              @click="choose(index)">
              <img :src='"../../assets/images/family_"+index+".png"'
                :class="{'active':index==avatar.index}">
              <div class="text">头像{{item}}</div>
              <!-- ccb -->
              <img v-show="index==avatar.index"
                v-if="BROSWER_TYPE==16"
                src='../../assets/images/theme/ccb/pac_radio.png'
                class="icon">
              <img v-show="index==avatar.index"
                v-else
                src='../../assets/images/pac_radio.png'
                class="icon">
            </div>
          </div>
          <div class="operate">
            <div class="operate-btn"
              @click="confirm">{{confirmBtnText}}</div>
          </div>
        </div>
        <div class="confirm-content text"
          v-if="type==2">
          <h2 class="title">{{title}}</h2>
          <!-- 阻止冒泡 以便正常滚动 -->
          <ol @touchmove.stop>
            <li class="item"
              v-for="(item, index) in data">{{index+1}}.{{item}}</li>
          </ol>
          <div class="operate">
            <div class="operate-btn"
              @click="confirm">{{confirmBtnText}}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>
export default {
  props: {
    type: {
      type: [String, Number],
      default: 0
    },
    text: {
      type: String,
      default: ''
    },
    confirmBtnText: {
      type: String,
      default: '确定'
    },
    cancelBtnText: {
      type: String,
      default: '取消'
    },
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array
    },
    avatar: {},
    btnLen: {
      default: 2
    }
  },
  data () {
    return {
      showFlag: false,
      BROSWER_TYPE: BROSWER_TYPE
    }
  },
  methods: {
    show () {
      this.showFlag = true
    },
    hide () {
      this.showFlag = false
    },
    cancel () {
      this.hide()
      this.$emit('cancel')
    },
    confirm () {
      this.hide()
      this.$emit('confirm')
    },
    choose (i) {
      // this.avatar.index = i;
      this.$emit('choose', i)
    }
  },

  computed: {
    operateBtnStyle () {
      if (this.btnLen < 2) {
        return {
          width: '100%'
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
@image: "../../assets/images/";
// @import "../assets/css/variable";
.theme-ccb {
  .confirm {
    .confirm-wrapper {
      .confirm-content {
        width: 660/200rem;
        height: 300/200rem;
        border-radius: 10/200rem;
        position: relative;
        .title {
          font-size: 34/200rem;
          color: @color-ccb-theme;
          padding: 35/200rem 0 0;
          margin-bottom: 20/200rem;
        }
        .text {
          // padding: 36/200rem 88/200rem 60/200rem;
          padding: 0 88/200rem 0;
          margin-top: 40/200rem;
        }
        .operate {
          width: 100%;
          position: absolute;
          bottom: 0;
          .operate-btn {
            font-size: 30/200rem;
            height: 80/200rem;
            line-height: 80/200rem;
            color: @color-ccb-theme;
          }
        }
        &.text {
          height: 800/200rem;
          position: relative;
          ol {
            padding: 0 44/200rem 0;
            max-height: 568/200rem;
            // overflow: scroll;
            .item {
              padding-bottom: 18/200rem;
            }
          }
          .operate {
            position: absolute;
            width: 100%;
            bottom: 0;
            .operate-btn {
              color: @color-ccb-theme;
              height: 80/200rem;
              line-height: 80/200rem;
              font-size: 30/200rem;
            }
          }
        }
        &.avatar {
          height: auto;
          .avatars {
            .avatar {
              img {
                &.active {
                  border-color: @color-ccb-theme;
                }
              }
            }
          }
          .text {
            margin-top: 0;
          }
          .operate {
            position: relative;
          }
        }
        &.top {
        }
      }
    }
  }
}
.confirm {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
  &.confirm-fade-enter-active {
    animation: confirm-fadein ease-in-out 0.3s;
    .confirm-content {
      animation: confirm-zoom ease-in-out 0.3s;
    }
  }
  &.confirm-fade-leave-active {
    animation: confirm-fadeout 0.2s;
    .confirm-content {
      animation: confirm-gone 0.2s;
    }
  }
  .confirm-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 51;
    .confirm-content {
      width: 690/200rem;
      border-radius: 6/200rem;
      background-color: #fff;
      .text {
        padding: 88/200rem 66/200rem;
        text-align: center;
        font-size: 32/200rem;
        line-height: 42/200rem;
        color: #4c4c4c;
      }
      .title {
        background-color: #fff;
        font-size: 36/200rem;
        color: @color-text-d;
        padding: 50/200rem 0 36/200rem;
        text-align: center;
      }
      &.avatar {
        .avatars {
          padding: 0 30/200rem;
          display: flex;
          justify-content: space-between;
          .avatar {
            position: relative;
            display: flex;
            flex-direction: column;
            img {
              border: 4/200rem solid transparent;
              border-radius: 50%;
              width: 130/200rem;
              height: 130/200rem;
              &.active {
                border-color: @color-theme;
              }
            }
            .icon {
              position: absolute;
              width: 36/200rem;
              height: 36/200rem;
              top: 96/200rem;
              left: 94/200rem;
            }
            .text {
              color: @color-text-l;
              font-size: 26/200rem;
              padding: 28/200rem 0 48/200rem;
            }
          }
        }
        .operate {
          .operate-btn {
            color: @color-text-d;
          }
        }
      }
      &.text {
        ol {
          padding: 0 50/200rem 26/200rem;
          .item {
            font-size: 30/200rem;
            color: @color-text-m;
            padding-bottom: 24/200rem;
            text-align: justify;
          }
        }
        .operate {
          .operate-btn {
            color: @color-theme;
          }
        }
      }

      .operate {
        display: flex;
        align-items: center;
        text-align: center;
        .operate-btn {
          font-size: 34/200rem;
          flex: 1;
          line-height: 92/200rem;
          height: 92/200rem;
          border-top: 1px solid #e0e0e0;
          color: @color-theme;
          &.left {
            color: #9c9c9c;
            border-right: 1px solid #e0e0e0;
          }
        }
      }
    }
  }
}
@keyframes confirm-fadein {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes confirm-fadeout {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes confirm-zoom {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes confirm-gone {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
</style>
